import image_one from "../assets/images/png/cm-yuva-yojna2.png";
import image_two from "../assets/images/png/cm-yuva-yojna3.png";
import image_five from "../assets/images/news/news_5.png";
import image_six from "../assets/images/news/news_6.png";
import image_three from "../assets/images/news/news_3.png";
import image_twoo from "../assets/images/news/news_2.png";
import image_onee from "../assets/images/news/news_one.png";
import img8 from "../assets/images/news/abhimanyu.jpg";
import img7 from "../assets/images/news/akhilender.jpg";

export const newsArticles = [
  {
    image: image_onee,
    title:
      "Haryana AVGC-XR Policy 2026: HKI Media Announces ₹10 Crore Centre of Excellence",
    desc: "As Haryana launches its AVGC-XR Policy 2026 under Make in Haryana vision, Gurgaon-based HKI Media steps up as an early mover with a ₹10 crore Centre of Excellence for animation, gaming, and immersive tech.",
    link: "https://aninews.in/news/business/haryana-bets-big-on-animation-and-gaming-as-a-gurgaon-startup-seeks-a-place-in-the-growth-story20260606121059/",
  },
  {
    image: image_twoo,
    title:
      "HKI Media to Build AVGC-XR Centre of Excellence in Haryana with R&D and Startup Incubation",
    desc: "HKI Media's planned AVGC-XR Centre of Excellence in Haryana will integrate R&D, IP creation labs, startup incubation, and VFX production infrastructure to build a future-ready creative technology ecosystem.",
    link: "https://theprint.in/ani-press-releases/haryana-bets-big-on-animation-and-gaming-as-a-gurgaon-startup-seeks-a-place-in-the-growth-story/2952503/",
  },
  {
    image: image_three,
    title:
      "HKI Media's ICASA to Bridge the Animation and Gaming Skills Gap Across India",
    desc: "Through ICASA's Learn • Create • Work & Earn model, HKI Media aims to close India's animation and gaming skills gap moving learners directly from training into employment within the AVGC-XR sector.",
    link: "https://www.latestly.com/agency-news/business-news-haryana-bets-big-on-animation-and-gaming-as-a-gurgaon-startup-seeks-a-place-in-the-growth-story-7461475.html",
  },
  {
    image: img8,
    title: "HKI Media Partners with National Skill Development Corporation",
    desc: "HKI Media has officially partnered with the National Skill Development Corporation and Startup Stairs, reinforcing its position as a driving force in shaping the future of India’s creative economy. ",
    link: "https://businessnewsthisweek.com/business/hki-media-partners-with-national-skill-development-corporation-and-startup-stairs-to-drive-national-entrepreneurship-in-indias-creative-economy/",
  },
  {
    image: img7,
    title: "HKI Media has launched the upgraded Gig Media app",
    desc: "A Media-tech platform designed to connect artists, performers and creative professionals with opportunities across India’s media and entertainment sector.",
    link: "https://sunitinews.blogspot.com/2026/03/hki-media-unveils-its-media-tech.html",
  },
  {
    image: image_two,
    title:
      "HKI Media Partners CM Yuva Mission to Launch 500 AVGC-XR Studios Across Uttar Pradesh",
    desc: "Lucknow (UP), December 22: In a significant move to boost India’s creative economy, HKI Media has partnered with the Chief Minister Yuva Udyami Yojana (CM YUVA Mission) to set up 500 AVGC-XR media studios across Uttar Pradesh, aimed at empowering youth and strengthening future-ready creative industries.",
    link: "https://aninews.in/news/business/hki-media-joins-hands-with-cm-yuva-yojana-to-launch-500-avgc-xr-studios-across-uttar-pradesh20251222132855/",
  },
  {
    image: image_one,
    title: "HKI Media Joins Hands with CM Yuva Yojana, 22nd Dec 2025",
    desc: "Lucknow (UP), December 22: In a major step toward strengthening India's creative economy, HKI Media has joined hands with the Chief Minister Yuva Udyami Yojana (CM YUVA Mission) to establish 500 AVGC-XR Media Studios across Uttar Pradesh.",
    link: "https://www.tribuneindia.com/news/business/hki-media-joins-hands-with-cm-yuva-yojana-to-launch-500-avgc-xr-studios-across-uttar-pradesh/#:~:text=New%20Delhi%20%5BIndia%5D%2C%20December,Media%20Studios%20across%20Uttar%20Pradesh",
  },
  {
    image: image_five,
    title:
      "ऐतिहासिक साझेदारी: HKI मीडिया ने भारत के पहले सरकारी कौशल विश्वविद्यालय SVSU के साथ किया MoU साइन",
    desc: "लखनऊ- मीडिया ने श्री विश्वकर्मा स्किल यूनिवर्सिटी (SVSU) के साथ ऐतिहासिक समझौता ज्ञापन पर हस्ताक्षर किएHKI मीडिया ने श्री विश्वकर्मा स्किल यूनिवर्सिटी (SVSU) के साथ आधिकारिक रूप से एक समझौता ज्ञापन",
    link: "https://sandaulitimes.com/9006/",
  },
  {
    image: image_six,
    title:
      "युवाओं को मिलेगा क्रिएटिव करियर का नया रास्ता, HKI मीडिया और SVSU ने किया MoU",
    desc: "Lucknow (Pawan Kumar) : हरियाणा के छोटे शहरों और गांवों में आज भी ऐसे हजारों युवा हैं, जिनके मन में कैमरे के पीछे की दुनिया को लेकर सपना तो है, लेकिन रास्ता साफ नहीं। कोई मोबाइल से वीडियो बनाता है, कोई एडिटिंग सीखना चाहता है, तो कोई एंकरिंग या स्क्रिप्ट राइटिंग में अपना भविष्य देखता है। मगर सही ट्रेनिंग, प्लेटफॉर्म और दिशा न मिलने की वजह से कई सपने बीच में ही रुक जाते हैं।",
    link: "https://newssamvad.com/uttar-pradesh-hindi-news/youth-to-discover-new-avenues-for-creative-careers-hki-media-and-svsu-sign-mou-117245.html",
  },
];
